export const comments_3296367 = {"data":{"data":[],"links":{}}}